<script setup>
import { onMounted } from 'vue';
import useAuth from '@/auth/useAuth';
import WaiverReview from '@/components/eventWaiver/waiversReview/WaiverReview.vue';

const {
  token,
  initializeMsal,
  handleSignIn,
  handleSignOut,
} = useAuth();

const initializeAuth = async () => {
  try {
    await initializeMsal();
  } catch (error) {
    console.log('Initialize error: ', error);
  }
};

const handleLogin = async () => {
  await handleSignIn();
};

const handleLogout = () => {
  handleSignOut();
};

onMounted(async () => {
  await initializeAuth();
  await handleLogin();
});
</script>

<template>
  <div v-if="token">
    <header>
      <h2>Storytelling Competition | Waiver Review</h2>
      <button class="black-btn" @click="handleLogout">Log out</button>
    </header>
    <WaiverReview :token="token" />
  </div>
</template>

<style lang="scss" scoped>
header {
  position: relative;
  padding: 20px;

  h2 {
    margin-bottom: 40px;
    font-size: clamp(1.5rem, 1.1538rem + 1.5385vw, 3rem);
    font-family: 'Avenir';
  }

  .black-btn {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>
